export const replaceResourceString = (content: string, resourceStringName: string, resourceStringValue: string) => {
    return content
        .replace(/{RESOURCESTRING:/, '')
        .replace(/}/, '')
        .replace(resourceStringName, resourceStringValue);
};

export type HeaderNFooter = {
    header: Header;
    footer: Footer;
};

type Header = Record<HeaderIcons, HeaderIcon> & PhoneIcon;

enum HeaderIcons {
    FLIGHT_ICON = 'flightIcon',
    FLIGHT_PLUS_HOTEL_ICON = 'flightPlusHotelIcon',
    HOTEL_ICON = 'hotelIcon',
    CAR_HIRE_ICON = 'carHireIcon',
    MYTRIP_ICON = 'myTripIcon',
}

type HeaderIcon = {
    show: boolean;
    text: string;
    link?: string;
};

export type PhoneIcon = {
    phoneIcon: HeaderIcon & {
        modalContent: {
            newBooking: NewBooking;
            callChargesInfo: string;
            existingBooking: ExistingBooking;
        };
    };
};

type NewBooking = {
    openHeading: string;
    closeHeading: string;
    openingHours: OpeningHoursDay[];
};

export type OpeningHoursDay = {
    dayOfWeek: number;
    opening: {
        hours: number;
        minutes: number;
    };
    closing: {
        hours: number;
        minutes: number;
    };
    closed: boolean;
};

type ExistingBooking = {
    heading: string;
    telephoneNumber: string;
    timings: Schedule[];
};

type Schedule = {
    day: string;
    timing: string;
};

type Footer = {
    footerLinks: FooterLink[];
    htmlContent: string;
    svgIcons: SvgIcons[];
    paymentOptions: {
        label: string;
        supportedCards: SupportedCards[];
    };
    socialMediaLinks: {
        label: string;
        platforms: Platform[];
    };
};

type Platform = {
    name: Platforms;
    link: string;
};

export enum Platforms {
    FACEBOOK = 'FACEBOOK',
    TWITTER = 'TWITTER',
    INSTAGRAM = 'INSTAGRAM',
    YOUTUBE = 'YOUTUBE',
    PINTEREST = 'PINTEREST',
    WHATSAPP = 'WHATSAPP',
}

export enum SvgIcons {
    ATOL_PROTECTED = 'ATOL_PROTECTED',
    IATA = 'IATA',
    ABTA = 'ABTA',
    TRAVEL_AWARE = 'TRAVEL_AWARE',
}

export enum SupportedCards {
    VISA = 'VISA',
    MASTER_CARD = 'MASTER_CARD',
    MAESTRO = 'MAESTRO',
    AMEX = 'AMEX',
}

type FooterLink = {
    name: FooterLinks;
    text: string;
    url: string;
    rel?: string;
    target?: string;
};

enum FooterLinks {
    BOOK_WITH_CONFIDENCE = 'bookWithConfidence',
    CAREERS = 'careers',
    PRICING_TNC = 'pricingTnC',
    PRIVACY_NOTICE = 'privacyNotice',
    TNC = 'tnc',
    SPECIAL_ASSISTANCE = 'specialAssistance',
    LAST_MINUTE_FLIGHTS = 'lastMinuteFlights',
    BLOG = 'blog',
    MODERN_SLAVERY_ACT = 'modernSlaveryAct',
    TAX_STRATEGY = 'taxStrategy',
    BREXIT = 'brexit',
}
